import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dialog-shipment-content-detail-dialog',
    templateUrl: 'shipment-content-detail-dialog.html',

})
export class ShipmentContentDetailDialog implements OnDestroy, OnInit {


    shipmentData: any;
    contentList: any[] = [];

    constructor(
        public dialogRef: MatDialogRef<ShipmentContentDetailDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
    ngOnInit(): void {
        this.shipmentData = this.data;
        this.contentList = this.data.content; 

        

    }
    close(): void {
        this.dialogRef.close();
    }

    onEditItem() {
        this.dialogRef.close();
    }
    ngOnDestroy(): void {
        this.shipmentData = {};
    }
    trackByIndex(index: number, item: any): any {
        return item;
      }
}